import styled from "@emotion/styled";
import { Avatar, Button } from "@mui/material";
import { Theme } from "@mui/material/styles/createTheme";
import Badge from "@mui/material/Badge";
import { HHNTheme } from "hhn-commons";
import { shouldForwardProp } from "../common/Common.style";
import theme from "../theme";

export const OrganizationHeader = styled.div`
  background-color: ${props => (props.theme as Theme).palette.primary.main};
  height: 60px;
  text-align: center;
  color: ${HHNTheme.common.white};
  font-size: 30px;
  font-weight: bold;
  padding: 6px;
`;

export const AvatarStyle = styled(Avatar)`
  text-transform: capitalize;
  font-size: 1.1rem;
  border: 1px solid ${theme.palette.divider};
`;

export const OrgLogoutButton = styled(Button)`
  margin: 8px 16px 16px;
  text-align: right;
  float: right;
`;

export const NoOrganizationContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100px;
`;

// ... (imports and other code)

export const OnlineStatusBadge = styled(Badge, {
  shouldForwardProp: prop =>
    shouldForwardProp<{ isOnline?: boolean }>(["isOnline"], prop),
})<{ isOnline?: boolean; theme?: Theme }>(({ isOnline, theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: isOnline
      ? theme.palette.success.main
      : theme.palette.error.main,
    color: isOnline ? theme.palette.success.main : theme.palette.error.main,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));
